module.exports = {"510403001":"清香坪街道","510403002":"玉泉街道","510403003":"河门口街道","510403004":"陶家渡街道","510403005":"摩梭河街道","510403006":"大宝鼎街道","510403100":"格里坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510403.json
// module id = 2102
// module chunks = 0